import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Card, Image, Paper, Stack, Text, rem, useMatches } from '@mantine/core';
import { ReferralMissionItem } from './ReferralMissionItem';
export const ReferralMissionCard: React.FC = () => {
  const top = useMatches({
    base: rem(0),
    sm: rem(-20),
    lg: rem(-30)
  });
  const right = useMatches({
    base: rem(-12),
    sm: rem(-14),
    lg: rem(-60)
  });
  const {
    i18n
  } = useLingui();
  return <Card radius={5} bg="var(--navbar-bg-color)" h="100%" style={{
    overflow: 'visible'
  }} mb={20}>
      <Card.Section>
        <Paper bg="linear-gradient(104.04deg, #F5FF6B 0%, #FF2A7F 100%)" px={20} radius={5} py={{
        base: 20,
        sm: 40
      }} pos="relative" style={{
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      }}>
          <Image src="/assets/profile/wheel.png" w={{
          base: 135,
          sm: 170,
          lg: 220
        }} h={{
          base: 135,
          sm: 170,
          lg: 220
        }} pos="absolute" top={top} right={right} />
          <Box miw={260}>
            <Text fz={13} className={gunterzBold.className} c="dark.7">
              {i18n._('Referral race')}
            </Text>
            <Text fz={{
            base: 28,
            sm: 32
          }} className={gunterzBold.className} c="dark.7" lh="32px" mt={8}>
              {i18n._('Score a Legendary!')}
            </Text>
          </Box>
        </Paper>
      </Card.Section>

      <Stack justify="space-between">
        <Stack gap={20} mt={24}>
          <ReferralMissionItem step={1} mission={i18n._('Share your link')} />
          <ReferralMissionItem step={2} mission={i18n._('Get friends to verify and deposit')} />
          <ReferralMissionItem step={3} mission={i18n._('Climb the leaderboard!')} />
        </Stack>

        <Card.Section>
          <Stack bg="var(--bg-400)" mt={33} h="100%" justify="center" align="center" style={{
          borderBottomLeftRadius: 5,
          borderBottomRightRadius: 5
        }}>
            <Text fz={13} ta="center" c="var(--text-dark)" tt="uppercase" fw={700} py={2} maw={{
            lg: 296
          }}>
              {i18n._('Top 3 Referrers Win a Legendary, Epic and Rare Item! 🔥')}
            </Text>
          </Stack>
        </Card.Section>
      </Stack>
    </Card>;
};